import { Mail, Users } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import {
  XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
  AreaChart, Area,
} from "recharts";
import { StatCard, SectionHeader, ChartTooltipContent } from "./ReportsShared";

export const CommunicationSection = ({ communication }) => (
  <section data-testid="section-communication" id="section-email">
    <SectionHeader icon={Mail} title="Email & Communication" subtitle="Reminders and engagement" />
    <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mb-4">
      <StatCard icon={Mail} label="Emails Sent" value={communication.total_emails_sent} color="#2563eb" />
      <StatCard icon={Users} label="SMTP Configured" value={`${communication.smtp_configured_users}/${communication.total_users}`} sub="users with email enabled" color="#059669" />
      <StatCard icon={Mail} label="SMTP Coverage" value={`${communication.total_users > 0 ? Math.round(communication.smtp_configured_users / communication.total_users * 100) : 0}%`} color="#7c3aed" />
    </div>
    <Card className="card-surface" data-testid="reminders-weekly-chart">
      <CardHeader className="py-3 px-5">
        <CardTitle className="text-xs font-semibold uppercase tracking-wider" style={{ color: "var(--t-text-muted)" }}>Reminders Sent (Weekly)</CardTitle>
      </CardHeader>
      <CardContent className="px-2 pb-4">
        {communication.reminders_by_week.length > 0 ? (
          <ResponsiveContainer width="100%" height={200}>
            <AreaChart data={communication.reminders_by_week}>
              <CartesianGrid strokeDasharray="3 3" stroke="var(--t-border)" />
              <XAxis dataKey="week" tick={{ fontSize: 11, fill: "var(--t-text-muted)" }} />
              <YAxis tick={{ fontSize: 11, fill: "var(--t-text-muted)" }} allowDecimals={false} />
              <Tooltip content={<ChartTooltipContent />} />
              <Area type="monotone" dataKey="count" name="Sent" stroke="#2563eb" fill="#2563eb" fillOpacity={0.15} strokeWidth={2} />
            </AreaChart>
          </ResponsiveContainer>
        ) : (
          <p className="text-center py-10 text-sm" style={{ color: "var(--t-text-muted)" }}>No email activity recorded yet</p>
        )}
      </CardContent>
    </Card>
  </section>
);
